import { PAYMENT_LINK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const PaymentLink = ObjectDefinitionRecord({
  hasAccess: (__isUngated, hasScope) => hasScope('payment-links-read'),
  objectTypeId: PAYMENT_LINK_TYPE_ID,
  referenceObjectType: 'PAYMENT_LINK_PROPERTIES'
});
export default PaymentLink;